<template>
  <div>
    <Header />
    <Table v-if="!account.suspended" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Header from "./overview/Header";
import Table from "./overview/Table";

export default {
  name: "dashboard-overview",
  components: { Header, Table },
  computed: {
    ...mapGetters("account", ["account"]),
  },
};
</script>

<style></style>
